<template>
  <div id="daily-records-list">
    <div class="fitler-form">
      <ElForm class="elementui-common-form-styles" v-highlight label-width="50" inline>
        <ElFormItem label="发送状态">
          <el-select v-model="queryForm.status" clearable style="width: 100px" placeholder="全部">
            <el-option v-for="item in DailyReports.REPORTS_SEND_STATUS_LIST" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="发送时间">
          <DateRangePicker v-model="queryForm.datetime" :clearable="false" style="width: 220px" />
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <el-button type="primary" @click="queryAction">查询</el-button>
        </ElFormItem>
      </ElForm>
    </div>

    <Viewport v-model="recordsGridOptions.height" v-loading="tableLoading">
      <vxe-grid ref="xGrid" v-bind="recordsGridOptions">
        <!-- 操作列 -->
        <template #operation="{ row }">
          <el-button
            type="text"
            @click="download(row)"
            :loading="row.downloading"
            v-if="row.sendStatus === DailyReports.REPORTS_SEND_STATUS.SUCC"
            >报表下载</el-button
          >
          <el-button type="text" @click="redo(row)" v-if="showInOneMonth(row)">重新发送</el-button>
        </template>
      </vxe-grid>

      <div class="pager">
        <el-pagination
          :current-page.sync="pager.pageIndex"
          :page-size.sync="pager.pageSize"
          :total="pager.total"
          @current-change="search"
          layout="prev, pager, next"
          background
        >
        </el-pagination>
      </div>
    </Viewport>
  </div>
</template>
<script>
import moment from 'moment'
import DailyReports from './data/daily.class.js'
import { getTaskSendRecordsById, reTryRecordById, queryByRecordId } from '@/api/report.model'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import { openNewWindow } from '@/common/js/utils'

export default {
  name: 'daily-task-records',
  components: { DateRangePicker },
  data() {
    const today = moment().format('YYYY-MM-DD')
    const start = moment().subtract(7, 'days').format('YYYY-MM-DD')

    return {
      tableLoading: false,
      queryForm: {
        status: '',
        datetime: [start, today]
      },
      pager: {
        pageIndex: 1,
        pageSize: 20,
        total: 0
      },
      recordsGridOptions: DailyReports.getRecordsGridOptions()
    }
  },
  computed: {
    DailyReports() {
      return DailyReports
    }
  },
  created() {
    this.queryAction()
  },
  methods: {
    /**
     * @description: 通过表格上面的查询表单触发的查询页码归1
     */
    queryAction() {
      this.pager.pageIndex = 1
      this.search()
    },
    /**
     * @description: 查询任务发送列表
     */
    search() {
      const { taskId } = this.$route.query
      if (!taskId) return

      const { datetime, status } = this.queryForm
      const [beginTime, endTime] = datetime || []
      const { total, ...pager } = this.pager

      const params = {
        beginTime,
        endTime,
        taskId,
        status,
        ...pager
      }
      const { SUCC, FAIL } = DailyReports.REPORTS_SEND_STATUS
      if (![SUCC, FAIL].includes(status)) params.status = -1

      this.tableLoading = true

      getTaskSendRecordsById(params).then((data) => {
        const { list, page_info } = data
        this.recordsGridOptions.data = list
        this.pager.total = page_info.total_number
        this.tableLoading = false
      })
    },
    /**
     * @description: 下载报表
     */
    download(row) {
      this.$set(row, 'downloading', true)
      queryByRecordId({ recordId: row.id })
        .then((data) => {
          const url = data.reportDownUrl
          if (url) {
            openNewWindow(url)
          }
          this.search()
          this.$set(row, 'downloading', false)
        })
        .catch(() => {
          this.$set(row, 'downloading', false)
        })
    },
    /**
     * @description: 重新发送只显示新建时间开始起一个月内的记录
     * @param {*} row
     */
    showInOneMonth(row) {
      return moment().subtract(1, 'month').isBefore(moment(row.addTime))
    },

    /**
     * @description: 重新发送
     */
    redo(row) {
      this.$Modal.confirm({
        title: '确认',
        content: `重新发送报表：${row.reportName}？`,
        onOk: () => {
          reTryRecordById({ id: row.id }).then((data) => {
            if (data) {
              this.$Message.success('已提交报表生成任务，请耐心等待结果')
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#daily-records-list {
  padding: 10px 0 0 0;
  .pager {
    text-align: right;
    padding-top: 10px;
  }
}
</style>
